<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para Gestión de Facturación</h2>
      <p class="help-introduction">Esta sección facilita la administración de facturas y planillas relacionadas con las atenciones médicas. Aquí puedes gestionar y procesar facturas eficientemente:</p>
      <ul class="help-list">
        <li><strong>Filtrar por Estado:</strong> Selecciona el estado de las atenciones para filtrar los registros, ya sea atenciones finalizadas o planillas generadas.</li>
        <li><strong>Buscar por Cédula o Nombre:</strong> Utiliza los campos de búsqueda para filtrar registros específicos mediante la cédula o el nombre del paciente.</li>
        <li><strong>Ver Todos los Registros:</strong> Utiliza el botón "Todos los registros" para mostrar todos los registros sin aplicar filtros.</li>
        <li><strong>Generar CSV:</strong> Exporta la información visible en la tabla a un archivo CSV haciendo clic en el botón "Generar CSV".</li>
        <li><strong>Acciones sobre Registros:</strong> Realiza acciones específicas como ver la planilla, generar planilla y generar factura utilizando el menú desplegable en cada fila de la tabla.</li>
        <li><strong>Actualizar o Ver Detalles:</strong> Cada registro puede ser editado o revisado en detalle haciendo clic en los íconos correspondientes al lado de cada registro.</li>
      </ul>
      <p class="help-conclusion">Asegúrate de revisar y confirmar los datos antes de proceder con la generación de facturas o planillas para evitar errores administrativos.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "AyudaFacturacion",
  };
  </script>
  <style src="@/assets/css/ayuda.css" scoped></style>